var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIssuerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#1968FF",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M7.08 21.21v1.35c0 .176.142.32.322.32h15.341c.177 0 .321-.144.321-.32v-1.35c0-.177-.144-.321-.321-.321H7.402c-.18 0-.322.144-.322.321zM7.321 11.976H22.67c.18 0 .321-.144.321-.321v-.851c0-.126-.07-.241-.183-.293l-7.466-3.48c-.084-.041-.18-.041-.267-.002L7.19 10.508c-.116.051-.19.167-.19.296v.851c0 .177.145.321.321.321zM8.655 19.135c-.18 0-.322.144-.322.32v.791h3.621v-.79c0-.177-.144-.321-.321-.321h-.186v-5.408h.186c.177 0 .321-.141.321-.321v-.787h-3.62v.787c0 .18.14.321.32.321h.184v5.408h-.183zM18.36 19.135c-.18 0-.32.144-.32.32v.791h3.617v-.79c0-.177-.141-.321-.321-.321h-.183v-5.408h.183c.18 0 .321-.141.321-.321v-.787h-3.618v.787c0 .18.142.321.322.321h.183v5.408h-.183zM13.506 19.135c-.177 0-.321.144-.321.32v.791h3.62v-.79c0-.177-.144-.321-.32-.321H16.3v-5.408h.183c.177 0 .322-.141.322-.321v-.787h-3.621v.787c0 .18.144.321.321.321h.183v5.408h-.183z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuerIcon);
export default __webpack_public_path__ + "static/media/issuer-icon.5984f72f55ab5910e0128f8ee7c31b9e.svg";
export { ForwardRef as ReactComponent };